export default {
    modelValue: {
        type: [Number, String],
        default: undefined
    }, 
    decreaseButtonTitle: {
        type: String,
        default: undefined
    }, 
    dragHandleTitle: {
        type: String,
        default: undefined
    }, 
    increaseButtonTitle: {
        type: String,
        default: undefined
    }, 
    largeStep: {
        type: Number,
        default: undefined
    }, 
    max: {
        type: Number,
        default: undefined
    }, 
    min: {
        type: Number,
        default: undefined
    }, 
    orientation: {
        type: String,
        default: undefined
    }, 
    showButtons: {
        type: Boolean,
        default: undefined
    }, 
    smallStep: {
        type: Number,
        default: undefined
    }, 
    tickPlacement: {
        type: String,
        default: undefined
    }, 
    tooltip: {
        type: Object,
        default: undefined
    }, 
    value: {
        type: [String, Number],
        default: undefined
    },

    // Events
    change: Function, 
    slide: Function
}


// WEBPACK FOOTER //
// ./packages/kendo-inputs-vue-wrapper/src/KendoSlider/SliderProps.js